import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-confirm-files',
  templateUrl: './modal-confirm-files.component.html',
  styleUrls: ['./modal-confirm-files.component.scss']
})
export class ModalConfirmFilesComponent implements OnInit {

  @Output() confirmSucces = new EventEmitter<void>();
  
    constructor(public modal: ModalService) { }
  
    ngOnInit() {
    }
    onDelete() {
      this.confirmSucces.emit();   
      this.modal.close();
    }
    closeModal() {
      this.modal.close();
    }
  

}
